<template>
  <div class="header-dots">
    <b-dropdown
      ref="notificationsdropdown"
      toggle-class="p-0 mr-2"
      menu-class="dropdown-menu-xl"
      variant="link"
      no-caret
      right
    >
      <span slot="button-content">
        <div class="icon-wrapper icon-wrapper-alt rounded-circle">
          <div class="icon-wrapper-bg bg-danger"></div>
          <i class="lnr-bullhorn text-danger"></i>
          <div
            class="badge badge-dot badge-dot-sm"
            v-bind:class="{
              'badge-danger': $store.state.notificationsState
                ? $store.state.notificationsState.length > 0
                : false,
            }"
          >
            {{ $t('general.notifications') }}
          </div>
        </div>
      </span>
      <div class="dropdown-menu-header mb-0">
        <div class="dropdown-menu-header-inner bg-deep-blue">
          <div class="menu-header-image opacity-1 dd-header-bg-2"></div>
          <div class="menu-header-content text-dark">
            <h5 class="menu-header-title">{{ $t('general.notifications') }}</h5>
            <h6
              class="menu-header-subtitle"
              v-if="$store.state.notificationsState"
            >
              {{ $t('notifications.youHave') }}
              <b>{{ $store.state.totalNotView }}</b>
              {{ $t('notifications.unreadMessages') }}
            </h6>
          </div>
        </div>
      </div>
      <div class="nav-justified">
        <b-tabs class="card-header-tab-animation" card>
          <b-tab :title="$t('notifications.messages')" class="p-3" active>
            <div class="scroll-gradient">
              <div class="scroll-area-sm">
                <VuePerfectScrollbar class="scrollbar-container">
                  <div
                    class="
                      vertical-time-simple
                      vertical-without-time
                      vertical-timeline
                      vertical-timeline--animate
                      vertical-timeline--one-column
                    "
                  >
                    <div
                      class="vertical-timeline-item vertical-timeline-element"
                      v-bind:class="{
                        'dot-danger': item.status === 0,
                        'dot-success': item.status === 1,
                      }"
                      v-for="item in $store.state.notificationsState"
                      v-bind:key="item.id"
                    >
                      <div>
                        <span
                          class="vertical-timeline-element-icon bounce-in"
                        ></span>
                        <div
                          class="vertical-timeline-element-content bounce-in"
                        >
                          <h4 class="timeline-title">{{ item.title }}</h4>
                          <p>
                            <v-icon small>access_time</v-icon>
                            {{ item.created_at }}
                          </p>
                          <p v-html="item.message"></p>
                          <!-- <v-btn v-bind="options" v-if="item.notification_type_id >= 2" @click="item.notification_type_id === 2 ? toRoute('/validate_expenses') : toRoute('/rejected_expenses')">
                            {{$t('general.view')}}
                          </v-btn> -->
                          <div class="text-center">
                            <template>
                              <span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <a v-bind="options" v-on="on" class="notificationView"
                                      v-if="item.notification_type_id >= 2"
                                      @click="
                                          item.notification_type.id === 2
                                          ? toRoute('/validate_expenses')
                                         : item.notification_type.id === 3
                                                     ? toRoute('/rejected_expenses')
                                                     : toRoute('/approvals/validate-request')">
                                      {{ $t('general.view')  }}
                                    </a>
                                  </template>
                                  {{ $t('general.view') }}
                                </v-tooltip>
                              </span>
                            </template>
                            <template>
                              <span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <a
                                      v-bind="options"
                                      v-on="on"
                                      class="notificationMarkRead"
                                      v-if="item.notification_type_id >= 2"
                                      @click="markAsRead(item)"
                                    >
                                      {{ $t('notifications.markAsRead') }}
                                    </a>
                                  </template>
                                  {{ $t('notifications.markAsRead') }}
                                </v-tooltip>
                              </span>
                            </template>
                            <template>
                              <span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <a
                                      v-bind="options"
                                      v-on="on"
                                      class="notificationDelete"
                                      v-if="item.notification_type_id >= 2"
                                      @click="remove(item)"
                                    >
                                      {{ $t('general.delete') }}
                                    </a>
                                  </template>
                                  {{ $t('general.delete') }}
                                </v-tooltip>
                              </span>
                            </template>
                          </div>
                          <br /><br /><br />
                          <span class="vertical-timeline-element-date"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </b-tab>
        </b-tabs>
        <ul class="nav flex-column">
          <li class="nav-item-divider nav-item mt-0"></li>
          <li class="nav-item-btn text-center nav-item">
            <button
              class="btn-shadow btn-wide btn-pill btn btn-focus btn-sm"
              @click="showAllNotifications"
            >
              {{ $t('notifications.all') }}
            </button>
          </li>
        </ul>
      </div>
    </b-dropdown>
    <b-dropdown
      ref="localesdropdown"
      toggle-class="p-0 mr-2"
      variant="link"
      no-caret
      right
    >
      <span slot="button-content">
        <div class="icon-wrapper icon-wrapper-alt rounded-circle">
          <div class="icon-wrapper-bg bg-focus"></div>
          <div class="language-icon">
            <country-flag :country="country" class="opacity-8" />
          </div>
        </div>
      </span>
      <div class="dropdown-menu-header">
        <div class="dropdown-menu-header-inner pt-4 pb-4 bg-focus">
          <div class="menu-header-image opacity-05 dd-header-bg-4"></div>
          <div class="menu-header-content text-center text-white">
            <h6 class="menu-header-subtitle mt-0">
              {{ $t('general.chooseLanguage') }}
            </h6>
          </div>
        </div>
      </div>
      <button
        type="button"
        tabindex="0"
        class="dropdown-item"
        @click="setLocale('es')"
      >
        <country-flag country="MX" class="mr-3 opacity-8" />
        <span>Español</span>
      </button>
      <button
        type="button"
        tabindex="0"
        class="dropdown-item"
        @click="setLocale('en')"
      >
        <country-flag country="US" class="mr-3 opacity-8" />
        <span>English</span>
      </button>
    </b-dropdown>
    <v-dialog v-model="removeDialog" max-width="500px">
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black error--text mb-0">
            {{ $t('notifications.delete') }}
          </h2>
        </v-toolbar>
        <v-card-text class="text-sm-justify">
          <p>{{ $t('notifications.confirmDelete') }}</p>
          <p class="font-weight-black">
            <span class="error--text">{{ $t('notifications.title') }}: </span
            >"{{ removedItem.title }}"
          </p>
          <p class="font-weight-black">
            <span class="error--text">{{ $t('general.date') }}: </span>"{{
              removedItem.created_at
            }}"
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error darken-1"
            round
            flat
            @click="removeDialog = false"
          >
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="error"
            round
            depressed
            @click="deleteItem(removedItem)"
          >
            {{ $t('general.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CountryFlag from 'vue-country-flag'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowUp, faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faArrowUp, faCog)

export default {
  components: {
    VuePerfectScrollbar,
    CountryFlag,
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      locale: 'es',
      notificationsKey: 0,
      notificationsActive: false,
      notifications: [],
      loading: false,
      removedItem: {},
      removeDialog: false,
    }
  },
  mounted() {
    this.locale = this.$i18n.locale
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale) {
        this.setLocale(savedLocale);
    } else {
        this.setLocale(this.locale); // Default or existing state
    }
    this.updateNotifications()
  },
  methods: {
    setLocale(value) {
      this.locale = value // SIRVE PARA CAMBIOS INTERNOS "CAMBIAR BANDERA"
      this.$i18n.locale = value // CAMBIA EL IDIOMA
      this.$vuetify.lang.current = value
      localStorage.setItem('locale', value);
      this.$refs.localesdropdown.hide() // OCULTA LA LISTA
    },
    toRoute(route) {
      this.$router.push(route)
    },
    updateNotifications() {
      if (
        this.$store.state.userState !== null &&
        this.$store.state.userLogged !== undefined &&
        this.$store.state.userLogged.id !== undefined
      ) {
        this.$store.dispatch('notifications/lastestNotView', {
          event: {
            context: this,
            application_id: 1,
          },
        })
      }
      if (this.showWizard()) {
        this.toRoute('/dashboard')
      }
    },
    showWizard() {
      if (
        this.userLogged.company !== undefined &&
        this.userLogged.user_info !== undefined
      ) {
        return (
          this.userLogged.roles[0].id === 2 &&
          this.userLogged.user_info.inicio === 0
        )
      } else {
        return false
      }
    },
    markAsRead(notification) {
      this.$store.dispatch('notifications/put', {
        event: {
          item: notification,
          context: this,
        },
      })
    },
    refresh() {
      this.updateNotifications()
    },
    showAllNotifications() {
      this.toRoute('/notifications')
      this.$refs.notificationsdropdown.hide()
    },
    close() {
      this.removeDialog = false
      this.loading = false
      this.removedItem = {}
    },
    remove(item) {
      this.removeDialog = true
      this.removedItem = Object.assign({}, item)
    },
    deleteItem(item) {
      this.loading = true
      this.$store.dispatch('notifications/delete', {
        event: {
          item: item,
          context: this,
        },
      })
    },
  },
  watch: {
    $route(to, from) {
      this.updateNotifications()
    },
    userLogged() {
      this.updateNotifications()
    },
  },
  computed: {
    country() {
      if (this.locale === 'es') return 'MX'
      else return 'US'
    },
    userLogged() {
      return this.$store.state.userLogged
    },
    options() {
      return {
        color: 'info',
        small: true,
        absolute: true,
        right: true,
        round: true,
      }
    },
  },
}
</script>
<style scoped>
a.notificationView {
  color: blue;
  padding-right: 20px;
  font-weight: bold;
}
a.notificationView:hover {
  color: #12aeda;
}
a.notificationMarkRead {
  color: #ffa600;
  font-weight: bold;
  padding-right: 20px;
}
a.notificationMarkRead:hover {
  color: #12aeda;
}
a.notificationDelete {
  color: red;
  font-weight: bold;
  padding-right: 25px;
}
a.notificationDelete:hover {
  color: #12aeda;
}
</style>



// WEBPACK FOOTER //
// src/Layout/Components/Header/HeaderDots.vue